import React, { useState } from 'react';
import DefaultTextField from 'components/Utils/DefaultTextField';
import AddressFields from 'components/Patient/EditAddress/AddressFields';
import DefaultButton from 'components/Utils/NewDefaultButton';
import PropTypes from 'prop-types';
import { api } from 'careand-redux/api/ApiThunks';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import DefaultDatePicker from 'components/Utils/DefaultDatePicker';
import Icon from 'components/Utils/NewIcon';
import { DefaultSwitch as Switch } from 'services/UIUtils';

const NewContact = (props) => {
  const dispatch = useAppDispatch();
  const [contact, setContact] = useState(props.contact || {});
  const [loading, setLoading] = useState(false);

  async function onSubmit(select = false) {
    setLoading(true);
    const result = await dispatch(api.Contacts.addPhysicianContact({ physicianContact: contact }), {
      errorTitle: 'Contact',
    });
    if (result) {
      setContact(result);
      if (props.onSuccess) props.onSuccess(result, select);
    }
    setLoading(false);
  }

  function onChangeAddress(event) {
    let { name, value } = event.target;
    let address = contact.address || {};
    setContact({ ...contact, address: { ...address, [name]: value } });
  }

  function onChange(event) {
    let { name, value } = event.target;
    let data = { ...contact, [name]: value };
    setContact(data);
    if (props.onChange) props.onChange(data);
  }

  function onChangeSwitch(name, checked) {
    let data = { ...contact, [name]: checked };
    setContact(data);
    if (props.onChange) props.onChange(data);
  }

  return (
    <div className="new-contact padded-box">
      {props.buttons}
      <DefaultTextField label="Name" name="name" value={contact.name} onChange={onChange} />
      <DefaultTextField
        label="Specialty"
        name="specialty"
        value={contact.specialty}
        onChange={onChange}
      />
      <DefaultTextField label="Email" name="email" value={contact.email} onChange={onChange} />
      <DefaultTextField label="Phone" name="phone" value={contact.phone} onChange={onChange} />
      <DefaultTextField label="Fax" name="fax" value={contact.fax} onChange={onChange} />
      <DefaultTextField label="Notes" name="notes" value={contact.notes} onChange={onChange} />
      <DefaultTextField label="Alert" name="alert" value={contact.alert} onChange={onChange} />
      <Switch
        name="track_referrals"
        label="Track Referrals"
        padded={false}
        checked={contact.track_referrals !== false}
        onChange={(event, checked) => onChangeSwitch('track_referrals', checked)}
      />
      <div className="flex gap-2 mt-2">
        <DefaultDatePicker
          key={contact.unavailable_until}
          label="Unavailable Until"
          name="unavailable_until"
          placeholder="Unavailable Until"
          value={contact.unavailable_until}
          style={{ width: '100%' }}
          onChange={(e, value) => onChange({ target: { name: 'unavailable_until', value } })}
          forceLabel
        />
        <Icon
          src="trash"
          className="relative top-[10px] "
          style={{ color: 'black', opacity: 0.25 }}
          onClick={() => {
            onChange({
              target: { name: 'unavailable_until', value: undefined },
            });
          }}
        />
      </div>
      <span className="small-title mt-3">Address</span>
      <AddressFields address={contact.address} onChange={onChangeAddress} />

      <div className="row buttons-wrapper gap-5" style={{ marginTop: '15px' }}>
        <DefaultButton name="Save" onClick={() => onSubmit()} className="white" loading={loading} />
        <DefaultButton
          name="Save and Select"
          className="blue"
          onClick={() => onSubmit(true)}
          loading={loading}
        />
      </div>
    </div>
  );
};

NewContact.propTypes = {
  contact: PropTypes.object,
  onSuccess: PropTypes.func,
};

export default NewContact;
